import axios from 'axios'
import { REQUEST_TIMEOUT } from '@/constants'

const PATH_URL = import.meta.env.VITE_APP_PLATFORM_API
const VERSION = import.meta.env.VITE_APP_VERSION

let hasFetch: any = null

export const getVersionConfig = async () => {
  if (!hasFetch) {
    hasFetch = axios
      .post(
        PATH_URL + '/common/commonVersionConfig/getVersionConfig',
        {
          platformType: 'web',
          bizType: 'biWeb',
          version: VERSION
        },
        {
          timeout: REQUEST_TIMEOUT,
          headers: {
            platformtype: 'web',
            appId: 'haili001'
          }
        }
      )
      .then(async (res) => {
        if (!res.data?.data.url) {
          try {
            await ElMessageBox.confirm('检测到新版本，是否更新？', '新版本', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            })
            location.reload()
          } catch (e) {
            console.log(e)
          }
        }
        return res.data
      })
  }
  const res = await hasFetch
  // console.log(data)
  return res?.data
}
